import { useComponentsContext } from "@blocknote/react";

import UIcon from "lib/icons/untitled_ui/UIcon";
import { useStotlesBlockNoteEditor } from "../useStotlesBlockNoteEditor";

export default function AddImageButton() {
  const editor = useStotlesBlockNoteEditor();
  const Components = useComponentsContext();

  if (!Components) {
    return <></>;
  }

  return (
    <Components.FormattingToolbar.Button
      label=""
      icon={<UIcon icon="image04" />}
      mainTooltip="Add image"
      onClick={() => {
        const currentBlock = editor.getTextCursorPosition().block;
        editor.insertBlocks([{ type: "image" }], currentBlock, "after");
      }}
    />
  );
}
